import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Paragraph, Subheading } from '@treams/treams-ui';

import LearningEventsList from '../components/LearningEventsList';

export default function LearningEventProposalsContainer() {
	const { t } = useTranslation();

	const { data, loading } = graphql.useLearningEventProposalsQuery({
		variables: { first: 100 },
	});

	return (
		<>
			<Box mb={4}>
				<Subheading>{t('learning.events.proposals.title')}</Subheading>
				<Paragraph>{t('learning.events.proposals.description')}</Paragraph>
			</Box>

			<Flex flexWrap="wrap">
				<LearningEventsList
					events={data?.learningEventProposals as graphql.LearningEventConnection}
					loading={loading}
				/>
			</Flex>
		</>
	);
}
